import { AsyncPipe, NgClass, formatDate } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  Injector,
  Input,
  OnDestroy,
  ViewChild,
  inject,
  output,
  runInInjectionContext,
} from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import {
  SiaAction,
  SiaActionConfig,
  SiaActionFired,
  SiaActionsService,
} from '@sia/actions';
import { SiaWidgetDataService } from '@sia/inputs';
import {
  ComponentService,
  FileService,
  FilterConfig,
  SiaBaseScriptComponent,
  SiaChoiceDialogComponent,
  SiaComponentConfigPerspectives,
  SiaDateService,
  SiaGridAvatarComponent,
  SiaNewRouterService,
  SiaParamsAndPatternsService,
  SiaPreFiltersService,
  SiaRouteData,
  SiaSessionParam,
  SiaSessionService,
  SiaSignalrService,
  SiaSizeDetectorService,
  SiaTranslatePipe,
  SiaUserPermissions,
  SiaUsersService,
  SiaUtilsService,
  SiaWindowSize,
  YesNoDialogComponent,
  jsonDeepClone,
  notify,
  retriveCurrentRouteData,
} from '@sia/shared';

import {
  DxCheckBoxModule,
  DxColorBoxModule,
  DxDataGridComponent,
  DxDataGridModule,
  DxDateBoxComponent,
  DxDateBoxModule,
  DxTextBoxModule,
} from 'devextreme-angular';
import { DxTemplateModule } from 'devextreme-angular/core';
import {
  DxiColumnModule,
  DxoGroupingModule,
  DxoHeaderFilterModule,
  DxoPagerModule,
  DxoPagingModule,
  DxoSearchPanelModule,
  DxoSelectionModule,
} from 'devextreme-angular/ui/nested';
import { ColumnResizeMode, GridsEditMode } from 'devextreme/common/grids';
import CustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
import 'devextreme/data/odata/store';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { formatNumber } from 'devextreme/localization';
import * as pdf_exporter from 'devextreme/pdf_exporter';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver';
import { Guid } from 'guid-typescript';
import $ from 'jquery';
import { jsPDF } from 'jspdf';
import { Subscription } from 'rxjs';
import { ColConfig } from '../../interfaces/col-config';
import { GridConfig } from '../../interfaces/grid-config';
import { GridDataService } from '../../services/grid-data.service';
import { SiaGridFooterComponent } from '../sia-grid-footer/sia-grid-footer.component';

@Component({
  selector: 'sia-grid',
  templateUrl: './sia-grid.component.html',
  styleUrls: ['./sia-grid.component.scss'],
  standalone: true,
  imports: [
    SiaGridFooterComponent,
    SiaGridAvatarComponent,
    DxoHeaderFilterModule,
    DxoSearchPanelModule,
    MatProgressSpinner,
    DxoSelectionModule,
    DxoGroupingModule,
    SiaTranslatePipe,
    DxTemplateModule,
    DxCheckBoxModule,
    DxDataGridModule,
    DxColorBoxModule,
    DxoPagingModule,
    DxTextBoxModule,
    DxiColumnModule,
    DxDateBoxModule,
    DxoPagerModule,
    AsyncPipe,
    MatButton,
    NgClass,
  ],
})
export class SiaGridComponent
  extends SiaBaseScriptComponent
  implements OnDestroy
{
  private sizeDetectorService = inject(SiaSizeDetectorService);
  private siaWidgetDataService = inject(SiaWidgetDataService);
  private pAndPService = inject(SiaParamsAndPatternsService);
  private preFilterService = inject(SiaPreFiltersService);
  private siaActionsService = inject(SiaActionsService);
  private componentService = inject(ComponentService);
  private signalrService = inject(SiaSignalrService);
  private sessionService = inject(SiaSessionService);
  private routerService = inject(SiaNewRouterService);
  private usersService = inject(SiaUsersService);
  private utilsService = inject(SiaUtilsService);
  private dataService = inject(GridDataService);
  private dateService = inject(SiaDateService);
  private cdr = inject(ChangeDetectorRef);
  private file = inject(FileService);
  private injector: Injector = inject(Injector);

  @ViewChild(DxDataGridComponent, { static: false })
  dataGrid: DxDataGridComponent | undefined;
  @ViewChild(DxDateBoxComponent, { static: false })
  gridDateBox: DxDateBoxComponent | undefined;
  scrollTop?: number = 0;
  //#endregion
  gridSaved = output<any>();
  //#endregion
  gridReordered = output<any>();
  //#endregion
  gridAction = output<any>();
  //#endregion
  rowReordered = output<any>();
  //#endregion
  selectedKeysChange = output<any>();
  //#endregion
  selectedRowsDataChange = output<any>();
  @Input() gridType: string = 'DEFAULT';
  @Input() isPopUp: boolean = false;
  @Input() saveGridState: boolean = false;
  @ViewChild('gridFooter', { read: ElementRef }) gridFooterElement:
    | ElementRef
    | undefined;
  firstLoad: boolean = true;
  private _reloadPageIndex?: number | undefined;
  previousSort?: string;
  private _updatedCount: number = 0;
  clickedKey: any;
  latestSavedState: any;
  statePageIndex: any = 0;
  focusedRowIndex: any;
  scrolledIntoView: boolean = false;
  scrollTimeout: any;
  settedPageIndex: boolean = false;
  selectedRowsData: any[] = [];
  selectedRowsVisible: boolean = false;
  ExcelJS: any;
  get reloadPageIndex(): number | undefined {
    return this._reloadPageIndex;
  }
  set reloadPageIndex(value: number | undefined) {
    this._reloadPageIndex = value;
  }
  private _bulkAction: any;
  isRadar: boolean = false;
  isGroupedGrid: boolean = false;
  // private _comparisonPage: any;
  private _gridInformations:
    | { componentId: string; guid?: string | undefined }
    | undefined;
  // private _hasFilterPanel: boolean = false;
  _state: any;
  processIds: boolean = false;
  get bulkAction(): any {
    return this._bulkAction;
  }
  set bulkAction(value: any) {
    this._bulkAction = value;
    if (!value) {
      this.selectedKeys = [];
      this._selectionCrud = null;
      this.gridConf.selectionMode = 'none';
      return;
    }
    if (value.processOnFire) {
      this.processBulkAction();
      let t = setTimeout(() => {
        this.bulkAction = null;
      }, 0);
      this._timeouts.push(t);
      return;
    }
    if (value.allowSelection) {
      this.gridConf.selectionMode = 'multiple';
    } else {
      this.gridConf.selectionMode = 'none';
    }
    if (value.allowAllSelection && this.dataGrid?.selection) {
      this.dataGrid.selection.allowSelectAll = true;
    } else if (this.dataGrid?.selection) {
      this.dataGrid.selection.allowSelectAll = false;
    }
  }
  fullTextStyle = 'white-space: pre-line; overflow-wrap: break-word;';
  summaries: {
    column: string | undefined;
    summaryType: string | undefined;
    valueFormat: string;
    displayFormat: string;
  }[] = [];
  haveInputGridId: boolean = false;
  pageData: SiaRouteData = {};
  private _exportFileType: 'excel' | 'pdf' = 'excel';
  private _exportAll: boolean = false;
  columns: any[] = [];
  radarSelection: string | undefined;
  processBulkAction() {
    switch (this.bulkAction?.id) {
      case 'delete':
        var dialogRef = this.dialog.open(YesNoDialogComponent, {
          width: '350px',
          data: { title: 'Vuoi eliminare i record selezionati ? ' },
        });
        let s0 = dialogRef.afterClosed().subscribe((result: any) => {
          if (result) {
            this.selectedKeys.forEach((key) => {
              var property: string;
              let deleteObject: any = {};
              for (property in key) {
                deleteObject[property] = key[property];
              }
              this._store.remove(deleteObject).then((res: boolean) => {
                if (res) {
                  var index = this.dataGrid?.instance.getRowIndexByKey(key);
                  if (index) {
                    this.pushGridDataUpdate();
                  }
                }
              });
            });
            notify('Eliminati con successo', 2000, 'success');
            this.selectedKeys = [];
            this.bulkAction = null;
          }
        });
        this._subs.push(s0);

        break;
      case 'excel':
        this._exportFileType = 'excel';
        this._exportAll = false;
        this.exportDatagrid({});
        break;
      case 'ids':
        var idsArr = this.selectedKeys?.map((x) => {
          return x['id'];
        });
        let ids: string = idsArr?.join(';');
        this.processIds = true;
        this.dataService
          .idsClick(this._gridConfiguration.idsSP, ids, this._gridId ?? '')
          .then((res: boolean) => {
            if (res) {
              this.selectedKeys = [];
              this.bulkAction = null;
              notify('Operazione completata', 1500, 'success');
            }
            this.processIds = false;
          })
          .catch(() => {
            this.processIds = false;
          });
        break;
      case 'update':
        this.routerService.navigateMenuWithParams(
          'popup^' + this._selectionCrud,
          [
            { id: 'selected-keys', value: this.selectedKeys },
            { id: 'massive-update', value: true },
            { id: 'bar-type', value: 'row-warn' },
            {
              id: 'bar-message',
              value:
                this.i18nService.translate('Stai aggiornando ') +
                this.selectedKeys.length +
                this.i18nService.translate(' record'),
            },
          ],
          'update',
        );
        break;
      case 'excel-all':
        this._exportFileType = 'excel';
        this._exportAll = true;
        this.exportDatagrid({});
        break;
      case 'pdf':
        this._exportFileType = 'pdf';
        this._exportAll = false;
        this.exportDatagrid({});
        break;
      case 'merge':
        let selectedKeys = this.selectedKeys.filter((value, index) => {
          const _value = JSON.stringify(value);
          return (
            index ===
            this.selectedKeys.findIndex((obj) => {
              return JSON.stringify(obj) === _value;
            })
          );
        });
        let params = [{ id: 'selected-keys', value: selectedKeys }];
        if (this.gridConf.mergeCustomMenu) {
          // this.routerService.navigateToCrudMerge(
          //   this.gridConf.mergeCustomMenu,
          //   this._selectionCrud ?? '',
          //   params,
          // );
        } else {
          // this.routerService.navigateToCrudMerge(
          //   null,
          //   this._selectionCrud ?? '',
          //   params,
          // );
        }
        break;
      case 'comparison':
        // this.routerService.navigateToCrudComparison(this._selectionCrud ?? '', [
        //   { id: 'selected-keys', value: this.selectedKeys },
        // ]);
        break;
      case 'pdf-all':
        this._exportFileType = 'pdf';
        this._exportAll = true;
        this.exportDatagrid({});
        break;
      default:
        break;
    }
  }
  private _defaultPerspective: GridConfig = {};
  @Input() set gridInformations(val: { componentId: string; guid?: string }) {
    this._gridInformations = val;
    if (val) {
      this.pageData = { componentId: val.componentId, guid: val.guid };
      this.haveInputGridId = true;
      this._gridId = val.componentId;
      this.radarSelection = this.sessionService.getSessionParamValue(
        this._gridId + '-selection',
        this.pageData.guid ?? '',
      );
      this.isRadar = this.sessionService.getSessionParamValue(
        'isRadar',
        this.pageData.guid ?? '',
      );
      this.baseOperations(val.componentId);
    }
  }
  @Input() gridConfId: string | undefined;
  private _selectionCrud: string | undefined | null;
  private _gridHeight: number | undefined;
  get gridHeight(): number | undefined {
    return this._gridHeight;
  }
  @Input() set gridHeight(value: number | undefined) {
    // console.log(this.gridFooterElement);
    this._gridHeight = value;
  }
  @Input() isOrderable: boolean = false;
  @Input() selectedKeys: any[] = [];
  reloadingConfiguration: boolean = true;
  getSelectedKeys() {
    return this.selectedKeys;
  }
  private _gridConfiguration: GridConfig = {
    cols: [],
    preFilters: [],
    styleConditions: [],
  };
  private _pageSize: number = 20;
  elementId = Guid.create().toString();
  get pageSize(): number {
    if (!this._pageSize) return 20;
    return this._pageSize;
  }
  set pageSize(value: number) {
    this._pageSize = value;
  }

  private _subs: Subscription[] = [];
  private _timeouts: any[] = [];
  private _prefilterVisible: boolean = false;
  private _editParams: SiaSessionParam[] = [];
  private _dateWidgetEnable: boolean = false;
  private _autoExpand: boolean = true;
  private _dataSource: DataSource | undefined;
  private _store: CustomStore | undefined | any;
  private _gridId: string | null = null;
  private _gridConfId: string | null = null;
  private _keysIds: string[] = [];
  get keysIds(): string[] {
    return this._keysIds;
  }
  private _deviceType: string = 'MASTER';
  private _prefiltersHardSubScription: Subscription | undefined;
  _permissions: SiaUserPermissions = {};
  // private _componentBindingId: string = '';
  private _isMobile: boolean = false;

  get dataSource() {
    return this._dataSource;
  }
  get gridId() {
    return this._gridId;
  }
  get dateWidgetEnable() {
    return this._dateWidgetEnable;
  }

  get gridConf() {
    return this._gridConfiguration;
  }

  get prefilterVisible() {
    return this._prefilterVisible;
  }

  get autoExpand() {
    return this._autoExpand;
  }

  allowUpdating: boolean | undefined | null;
  allowAdding: boolean | undefined | null;
  allowDeleting: boolean | undefined | null;

  @HostListener('window:unload')
  ngOnDestroy() {
    this.saveState(this.latestSavedState);
    this._subs.forEach((sub) => {
      sub.unsubscribe();
    });
    this._subs = [];
    this._timeouts?.forEach((t) => {
      clearTimeout(t);
    });
    this._timeouts = [];
    clearTimeout(this.scrollTimeout);
    this._dataSource?.dispose();
    this.destroyDxComponent(this.gridDateBox, 'gridDateBox');
    this.destroyDxComponent(this.dataGrid, this.elementId);
    this._store = undefined;
    this.dataGrid = undefined;
    this._prefiltersHardSubScription?.unsubscribe();
    this.selectedKeys = [];
    this._editParams = [];
    this._keysIds = [];
    super.ngOnDestroy();
  }
  ngOnInit() {
    super.ngOnInit();
    let s0 = this.signalrService.refreshMessage$.subscribe((message) => {
      this.manageSiaSignalrMessage(message);
    });
    this._subs.push(s0);

    let s1 = this.sizeDetectorService.onResize$.subscribe(
      (data: SiaWindowSize | null) => {
        if (data) {
          this._deviceType = data.deviceType == 'MOBILE' ? 'MOBILE' : 'MASTER';
          this.updateGridConfig();
          this._isMobile = data.isMobile ?? false;
        }
      },
    );
    this._subs.push(s1);

    let s2 = this.siaActionsService
      .actionFired$()
      .subscribe((action: SiaActionFired) => {
        if (
          action.guid == this.pageData.guid &&
          action.componentId == this.pageData?.componentId
        ) {
          // console.log('Action Fired', action);
          this.manageActionFired(action);
        } else {
        }
      });
    this._subs.push(s2);
  }

  getGridConfResizingMode(mode: string) {
    let res: ColumnResizeMode = 'nextColumn';
    if (!mode) return res;
    if (mode == 'nextColumn' || mode == 'widget')
      return mode as ColumnResizeMode;
    return res;
  }

  //#region private methods
  private manageSiaSignalrMessage(message: any) {
    if (!message) {
      // console.warn('manageSiaSignalrMessage - messaggio Nullo');
      return;
    }
    // console.log('Arrivato messaggio SignalR');
    // console.log(message);

    if (!message[this._gridId ?? ''] && !message['*']) {
      // console.warn(
      //   'managSiaSignalrMessage - messaggio per un altro componente: ' +
      //     message.recipientId
      // );
      return;
    }
    this.pushGridDataUpdate();
  }

  private pushGridDataUpdate() {
    this.dataService.clearAllResponseContaining(this._gridId).then((_: any) => {
      if (this._store) {
        // this._store.push([{ type: 'update' }]);
        this.dataGrid?.instance.refresh();
      }
    });
  }

  private getGridStateSessionKey() {
    return ''.concat(
      this._gridId ?? '',
      this._deviceType,
      this.pageData.guid ?? '',
    );
  }

  setGridState(gridId: string, perspective: string, guid: string, state: any) {}

  private setGridSpParameters(gridId: string, parameters: any) {
    let k = 'grid-sp-parameters' + gridId;
    this.sessionService.set(k, parameters);
  }

  private clearGridState(gridId: string, perspective: string, guid: string) {
    let k = this.getGridStateSessionKey();
    this.sessionService.clear(k);
  }

  //Salva la configurazione delle colonne della grid così come me le passa
  //lo state
  private onSaveActualConfig() {
    var guid = this.pageData.guid;
    if (!guid || !this._gridId) return;
    var actualState = this.dataService.getGridState(
      this.getGridStateSessionKey(),
    );
    if (!actualState) {
      return;
    }
    if (!this._gridConfiguration) {
      return;
    }
    if (!this._gridConfiguration.cols) return;
    this._gridConfiguration.cols.forEach((col) => {
      var stateCol = this.getStateCol(col, actualState);
      if (stateCol) {
        col.sortOrder = stateCol.sortOrder;
        col.sortIndex = stateCol.sortIndex;
        col.visible = stateCol.visible;
        col.visibleIndex = stateCol.visibleIndex;
        col.width = stateCol.width;
        col.groupIndex = stateCol.groupIndex;
      }
    });
    var prefilters = this.preFilterService.generatePreFiltersFromTree(
      actualState.filterValue,
    );

    var actualValidPrefilters = this._gridConfiguration?.preFilters?.filter(
      (x) => x.pattern != '@StaticValue',
    );
    if (!actualValidPrefilters) actualValidPrefilters = [];
    this._gridConfiguration.preFilters = [
      ...actualValidPrefilters,
      ...prefilters,
    ];
  }
  private getStateCol(col: ColConfig, actualState: any) {
    if (!actualState) return col;
    if (!actualState.columns) return col;
    var actualStateCol = actualState.columns.filter(
      (x: any) => x.dataField == col.dataField,
    );
    if (actualStateCol && actualStateCol.length == 1) {
      return actualStateCol[0];
    }
  }
  private onConfigClick() {
    if (!this._gridConfId) {
      return;
    }
    this.clearActualState();
    this.routerService.navigateMenuWithParams('grid-config', [
      { id: 'gridId', value: this._gridConfId },
    ]);
  }

  private showColumnChooser() {
    if (this.dataGrid) {
      this.dataGrid.columnChooser.mode = 'select';
      this.dataGrid.columnChooser.height =
        ((this.gridHeight ?? 200) * 80) / 100;
      this.dataGrid?.instance.showColumnChooser();
    } else {
      // console.warn("showColumnChooser FALLITO. GRID NULLA");
    }
  }

  restoreColumns(prevCols: any[]) {
    if (!prevCols) {
      prevCols = jsonDeepClone(this.columns);
    }
    this.showSelected();
    // console.log('ripristino colonne grid dopo export');
    if (this.dataGrid) {
      this.dataGrid.columns.forEach((col: any) => {
        // console.log('Considero la colonna ', jsonDeepClone(col));
        let previousCol = prevCols.find((x) => x.dataField == col.dataField);
        // console.log('previousCol', jsonDeepClone(previousCol));
        this.dataGrid?.instance.columnOption(
          col.dataField,
          'visible',
          previousCol?.visible ?? false,
        );
      });
      this.dataGrid.instance.refresh();
      this.dataGrid.instance.repaint();
    }
  }

  exportDatagrid(e: any) {
    // console.log('******************* exportDatagrid', JSON.stringify(e));

    if (
      !this.dataGrid ||
      (!this._exportAll &&
        (!this.selectedKeys || this.selectedKeys.length == 0))
    ) {
      notify('Selezionare almeno un record.', 1500, 'error');
      return;
    }
    //Filtra solo le colonne esportabili come da configurazione
    var cols = jsonDeepClone(this.columns);
    this.dataGrid.columns.forEach((col: any) => {
      this.dataGrid?.instance.columnOption(
        col.dataField,
        'visible',
        col.allowExporting ?? false,
      );
    });

    this.dataGrid.instance.refresh();
    this.dataGrid.instance.repaint();
    if (this._exportFileType == 'excel') {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet();
      exportDataGrid({
        component: this.dataGrid.instance,
        worksheet,
        autoFilterEnabled: true,
        selectedRowsOnly: !this._exportAll,
        customizeCell: ({ gridCell, excelCell }) => {
          if (
            typeof gridCell?.value == 'string' &&
            gridCell.value.includes('_xlfn.')
          ) {
            excelCell.value = { formula: gridCell.value };
          }
        },
      }).then(() => {
        workbook.worksheets.forEach((worksheet: any) => {
          worksheet.fillFormula;
        });
        workbook.xlsx.writeBuffer().then((buffer: any) => {
          saveAs(
            new Blob([buffer], { type: 'application/octet-stream' }),
            (this.gridConf.exportFileName ?? 'Grid') + '.xlsx',
          );
        });
        this.restoreColumns(cols);
      });
    } else if (this._exportFileType == 'pdf') {
      const doc = new jsPDF({ orientation: 'l' });
      pdf_exporter
        .exportDataGrid({
          jsPDFDocument: doc,
          component: this.dataGrid.instance,
          indent: 5,
          selectedRowsOnly: !this._exportAll,
        })
        .then(() => {
          doc.save((this.gridConf.exportFileName ?? 'Grid') + '.pdf');
          this.restoreColumns(cols);
        });
    }

    this.bulkAction = null;
  }
  //prefiltri che arrivano da widget esterni
  private subscribeToPrefilters() {
    if (this._prefiltersHardSubScription) {
      return;
    }
    this._prefiltersHardSubScription =
      this.pAndPService.paramsHardUpdated$.subscribe((guid: string) => {
        if (guid != this.pageData.guid) {
          return;
        }
        this._updatedCount++;
        if (this._gridConfiguration.waitForFilter && this._updatedCount == 1) {
          return;
        }
        this.updateDataSource(true);
      });
  }

  private subscribeToEditParams() {
    if (!this.gridConf) return;
    if (!this.gridConf.editParams) return;
    if (this.gridConf.editParams.length == 0) return;
    this.gridConf.editParams.forEach((element) => {
      switch (element.pattern) {
        case 'SiaSessionParam':
          var value = this.preFilterService.getSessionParamValue(
            element.value.toString(),
            this.pageData.guid ?? '',
          );
          this._editParams.push({ id: element.id, value: value });
          break;
        default:
          break;
      }
    });
  }
  private updateGridConfig() {
    if (!this._gridConfId) {
      return;
    }
    if (!this._deviceType) {
      return;
    }
    if (!this._gridId) {
      return;
    }
    return this.componentConfigService
      .getDefaultPerspective('grid', this._gridId, this._deviceType ?? 'MASTER')
      .then(async (perspective: SiaComponentConfigPerspectives | null) => {
        if (!perspective?.jsonConfig) return;
        var config = JSON.parse(perspective.jsonConfig);
        //Tolgo prefiltri usati solo per conteggio
        config.preFilters = config.preFilters?.filter(
          (x: any) => (x.countFilter ?? false) == false,
        );
        this._defaultPerspective = config;
        await this.onGridConfUpdated(config);
      })
      .catch((err) => {
        console.error(err);
      });
  }
  private updateDataSource(addFilter: boolean = false) {
    if (!this._gridId) {
      return;
    }
    if (this._gridConfiguration && !this._gridConfiguration.preFilters) {
      this._gridConfiguration.preFilters = [];
    }
    if (this._gridConfiguration && !this._gridConfiguration.spParameters) {
      this._gridConfiguration.spParameters = [];
    }
    let sPreFilters: FilterConfig[] = [];

    let ff = {
      controlId: this._gridId,
      prefilters: [
        ...(this._gridConfiguration.preFilters ?? []),
        ...sPreFilters,
      ],
    };

    this.preFilterService.resolvePatterns(ff, this.pageData.guid ?? '');
    var sessionParams = this.pAndPService.convertInSessionParams(ff);
    if (this._gridConfiguration.useSp) {
      let spPreFilters: FilterConfig[] = [];
      let spff = {
        controlId: this._gridId,
        prefilters: [
          ...(this._gridConfiguration.spParameters ?? []),
          ...spPreFilters,
        ],
      };
      this.preFilterService.resolvePatterns(spff, this.pageData.guid ?? '');
      var sp = this.pAndPService.convertInSessionParams(spff);
      if (!this._gridConfId) {
        return;
      }
      this.setGridSpParameters(this._gridConfId, sp);
    }
    this.onTreeFiltersFromSiaSessionParams(sessionParams, addFilter);
    if (this.dataGrid?.instance) {
      // this.dataGrid?.instance.refresh();
      // this.dataGrid?.instance.repaint();
    }
    this.pAndPService.updateSiaSessionParamsWithGuid(
      sessionParams,
      this.pageData.guid ?? '',
    );
  }

  checkReportAction() {
    if (!this._gridConfiguration) return;
    if (!this._gridConfiguration.reportName) return;

    var reportAction: SiaActionConfig = {
      id: 'report',
      caption: '',
      visible: true,
      onlyAdmin: false,
      icon: 'print',
      width: 40,
      dataField: 'siaReport',
      cellTemplate: 'Template',
      customCellTemplate: 'ReportLink',
    };
    this._gridConfiguration.actions?.push(reportAction);
  }
  onEditorPreparing(e: any) {
    if (e.parentType === 'filterRow') {
      e.updateValueTimeout = 1000;
    }
  }
  private async onGridConfUpdated(gridConfiguration: GridConfig) {
    // console.log('*********************** onGridConfUpdated');
    var state = this.loadState();
    if (!gridConfiguration && !state) {
      // consolewarn("Configurazioni nulle");
      return;
    }

    if (this._gridId != this._gridConfId) {
      return;
    }

    this._gridConfiguration = gridConfiguration;

    if (this.dataGrid) {
      // this.dataGrid.scrolling = {
      //   mode: this._gridConfiguration.scrollingType,
      //   rowRenderingMode:
      //     this._gridConfiguration.scrollingType === 'page'
      //       ? 'standard'
      //       : 'standard',
      //   columnRenderingMode: 'virtual',
      //   preloadEnabled: true,
      // };
      this.dataGrid.scrolling = {
        mode: 'standard',
        rowRenderingMode: 'standard',
        columnRenderingMode: 'virtual',
        preloadEnabled: true,
      };
      this.dataGrid.remoteOperations = {
        sorting: true,
        paging: true,
        filtering: true,
        summary: this._gridConfiguration.useSp ? false : true,
      };
      this.dataGrid.sorting.mode = 'multiple';
      this.dataGrid.filterRow.visible =
        this._gridConfiguration.filterRowEnabled;
      this.dataGrid.groupPanel.visible =
        this._gridConfiguration.groupPanelEnabled;
    }
    this.checkReportAction();
    await this.refreshColumnsConf();
    if (!state) {
      this.pageSize = gridConfiguration.pageSize ?? 0;

      this.refreshValidationRulesConf();
    }
    this.refreshEditingConf();
    this.enableAddAction();
    this.refreshSummaryConf();
    this.checkFilterRow();
    this.subscribeToPrefilters();
    this.subscribeToEditParams();
    this.reloadingConfiguration = false;
  }
  private enableAddAction() {
    var falseParam: SiaSessionParam[] = [{ id: 'addVisible', value: false }];
    var trueParam: SiaSessionParam[] = [{ id: 'addVisible', value: true }];
    if (!this._gridConfiguration?.editType) {
      this.sessionService.updateSessionParams(
        this.pageData.guid ?? '',
        falseParam,
      );
      this.siaActionsService.actionParamsChanged();
      return;
    }
    switch (this._gridConfiguration.editType) {
      case 'nessuno':
        this.sessionService.updateSessionParams(
          this.pageData.guid ?? '',
          falseParam,
        );
        break;
      case 'batch':
      case 'row':
      case 'popup':
      case 'external page':
        this.sessionService.updateSessionParams(
          this.pageData.guid ?? '',
          trueParam,
        );
        break;
      default:
        break;
    }
    this.siaActionsService.actionParamsChanged();
  }
  private checkFilterRow() {}

  private refreshEditingConf() {
    if (
      this._gridConfiguration.editType != 'row' &&
      this._gridConfiguration.editType != 'batch'
    ) {
      this.allowAdding = false;
      this.allowUpdating = false;
      this.allowDeleting = false;
      return;
    } else {
      this.allowAdding =
        (this._permissions?.canCreate && this.gridConf.allowAdding) ?? false;
      this.allowUpdating =
        (this._permissions?.canUpdate && this.gridConf.allowUpdating) ?? false;
      this.allowDeleting =
        (this._permissions?.canDelete && this.gridConf.allowDeleting) ?? false;

      this.gridConf.allowMassiveUpdate =
        (this._permissions?.canUpdate && this.gridConf.allowMassiveUpdate) ??
        false;
      this.gridConf.allowMerge =
        (this._permissions?.canUpdate && this.gridConf.allowMerge) ?? false;
      this.gridConf.allowMassiveDelete =
        (this._permissions?.canDelete && this.gridConf.allowMassiveDelete) ??
        false;
    }
  }
  getDefaultFormattedValue(cellData: any) {
    if (cellData) {
      if (cellData.column.dataType == 'number') {
        return formatNumber(
          cellData.value,
          cellData.column.format ?? '###,###,###,###.##',
        );
      } else if (
        cellData.value &&
        (cellData.column.dataType == 'date' ||
          cellData.column.dataType == 'datetime')
      ) {
        // console.log(cellData.column, cellData.value);
        // check if cellData is a date or can be converted to a date
        try {
          if (typeof cellData.value === 'string') {
            cellData.value = new Date(cellData.value);
          }
          return formatDate(
            cellData.value,
            cellData.column.format ?? 'dd/MM/yy HH:mm:ss',
            'IT',
          );
        } catch (e) {
          return cellData.value;
        }
      }
    }
    return cellData.value;
  }

  getTemplateStyle(data: any) {
    var conditions = data.column.clickEnableCondition;
    if (conditions) {
      var res = this.pAndPService.validateConditionParamPattern(
        conditions,
        data.data,
        this.pageData.guid ?? '',
      );
      if (!res) return '';
    }
    if (
      data.column.dataType != 'icon' &&
      data.column.customCellTemplate != 'IconMaterial' &&
      data.column.onClick
    ) {
      return 'text-decoration : underline;color:#03A9F4;cursor:pointer';
    }
    return '';
  }

  getTemplateType(data: any) {
    // console.log(data);
    let template = '';
    if (!data) return template;
    if (!data.column) {
      // console.warn('data.column nullo');
      return template;
    }
    if (data.column.customCellTemplate) {
      return data.column.customCellTemplate;
    }
    let df = data.column.dataField;
    if (!df) {
      console.warn('data.column.dataField nullo');
      return template;
    }
    if (!this.columns || this.columns.length == 0) {
      return template;
    }

    let col = this.columns.filter((x: any) => x.dataField === df);
    if (!col || col.length == 0) {
      return template;
    }
    if (col[0].customCellTemplate) {
      return col[0].customCellTemplate;
    }
    return template;
  }

  //Ok conf cache
  private getConfParamValue(data: any) {
    let empty = '';
    if (!data) return empty;
    if (!data.column) {
      // console.warn("data.column nullo");
      return empty;
    }
    let df = data.column.dataField;
    if (!df) {
      // console.warn("data.column.dataField nullo");
      return empty;
    }
    if (!this._gridConfiguration) {
      return empty;
    }
    if (
      !this._gridConfiguration.cols ||
      this._gridConfiguration.cols.length == 0
    ) {
      return empty;
    }

    let col = this._gridConfiguration.cols.filter((x) => x.dataField === df);
    if (!col || col.length == 0) {
      return empty;
    }
    return col[0].cellTemplateParam ?? empty;
  }
  private onTreeFiltersFromSiaSessionParams(
    sessionParams: SiaSessionParam[],
    addFilter: boolean = false,
  ) {
    if (!this.dataGrid) {
      return;
    }
    if (!sessionParams || sessionParams.length == 0) {
      this.dataGrid.filterValue = [];
    } else {
      sessionParams.forEach((element) => {
        var col = this._gridConfiguration?.cols?.find(
          (x) => x.dataField == element.field,
        );
        element.dataType = col?.dataType;
      });

      let treeFilters =
        this.preFilterService.generateFiltersTreeFromSiaSessionParams(
          sessionParams,
        );
      // if (treeFilters && !this.dataGrid.filterValue && !addFilter) {
      //   this.dataGrid.filterValue = treeFilters;
      // } else if (addFilter) {
      this.addFilter(treeFilters);
      // }
      this.processGridFilters();
    }

    this._keysIds = [];
    if (this._gridConfiguration && this._gridConfiguration.cols) {
      this._gridConfiguration.cols.forEach((col) => {
        if (col && col.primaryKey) {
          if (col.dataField) this._keysIds.push(col.dataField);
        }
      });
    }

    // sessionParams.forEach((element) => {
    //   if (
    //     !element.value &&
    //     typeof element.value != 'boolean' &&
    //     this.dataGrid &&
    //     this.dataGrid.filterValue
    //   ) {
    //     var index = this.dataGrid.filterValue.findIndex(
    //       (x: any) => Array.isArray(x) && x[0] == element.field
    //     );
    //     if (index != -1) {
    //       if (index == 0) {
    //         this.dataGrid?.filterValue.splice(index, 2);
    //       } else {
    //         this.dataGrid?.filterValue.splice(index - 1, 2);
    //       }
    //     }
    //   }
    // });
    if (!this._store && this._gridId && this._gridConfId) {
      this.dataGrid.searchPanel.visible =
        this._gridConfiguration.actionSearchPanelEnabled;

      this.dataService
        .store(
          this._deviceType,
          this._gridId,
          this._gridConfiguration.useSp ?? false,
          this._keysIds,
          this._defaultPerspective,
          null,
          this,
        )
        .then((store: CustomStore) => {
          if (!this.dataGrid) return;
          this._store = store;
          this._dataSource = new DataSource({
            store: this._store,
            reshapeOnPush: true,
          });

          // export type GridsEditMode = 'batch' | 'cell' | 'row' | 'form' | 'popup';

          this.dataGrid.editing = {
            mode: this._gridConfiguration.editType as GridsEditMode,
            useIcons: true,
            allowAdding: this.allowAdding ?? false,
            allowUpdating: this.allowUpdating ?? false,
            allowDeleting: this.allowDeleting ?? false,
          };
          this.dataGrid.dataSource = this._dataSource;
          // this.dataGrid.instance.repaint();
          this.dataGrid.stateStoring = {
            customSave: this.saveState,
            customLoad: this.loadLoadedState,
            enabled: true,
            savingTimeout: 0,
            type: 'custom',
          };
          // this.dataGrid.instance.repaint();
          this.loadHeaderFiltersDataSource();
          this.cdr.detectChanges();
        });
    } else {
      if (this.dataGrid && this.dataGrid?.instance) {
        if (this._state) {
          this._state = null;
        } else {
          // console.log('--- this.dataGrid?.instance.refresh()');
          // console.log('gridId' + this.gridId);
          this.dataGrid?.instance.refresh();
          this.dataGrid?.instance
            ?.getDataSource()
            ?.reload()
            .then(() => {
              this.dataGrid?.instance.repaint();
              // console.log(this.gridId + '2');

              this.cdr.detectChanges();
            });
        }
      }
    }
  }
  loadLoadedState() {
    return this._state;
  }
  private loadHeaderFiltersDataSource(filters: string = '') {
    this.gridConf?.cols?.forEach((col) => {
      if (col?.allowHeaderFiltering) {
        let componentId = this.gridId;
        let dataField = col.dataField;
        this.dataService
          .getFilterDataSource(
            this.gridConf?.controller ?? '',
            componentId,
            dataField,
            filters,
          )
          .then((dataSource: { text: string; value: any }[]) => {
            var focused = $(':focus');
            this.dataGrid?.columns.map((x: any) => {
              if (x.dataField == dataField) {
                x.headerFilterDataSource = dataSource;
                col.headerFilterDataSource = dataSource;
              }
            });
            let t = setTimeout(() => {
              let ele = $(
                `input[aria-describedby='${focused.attr('aria-describedby')}']`,
              );
              if (ele) {
                ele.focus();
              }
            });
            this._timeouts.push(t);
          });
      }
    });
  }
  trackById(index: number, item: any) {
    return item.id;
  }
  private _oldFilters: string = '';

  onFilterValueChange(event: any) {
    if (!this._store) {
      return;
    }
    var filters = JSON.stringify(event);

    if (filters != this._oldFilters) {
      this._oldFilters = filters;
      this.loadHeaderFiltersDataSource(filters);
    } else {
    }
  }

  private clearDataGridInstance() {
    if (this.dataGrid?.instance) {
      this.dataGrid.instance.clearFilter();
      this.dataGrid.instance.clearSelection();
      this.dataGrid.instance.clearSorting();
      this.dataGrid.instance.option('columns', undefined);
      this.dataGrid.instance.option('dataSource', null);
      this._prefiltersHardSubScription?.unsubscribe();
      this._prefiltersHardSubScription = undefined;
      this.dataGrid.dataSource = [];
      this.columns = [];
      this._bulkAction = null;
      this.selectedKeys = [];
      // this.dataGrid.instance.refresh();
      this.cdr.detectChanges();
    }
  }
  private refreshSummaryConf() {
    let conf = this._gridConfiguration;
    if (!this.dataGrid) return;
    if (!conf) return;
    if (!conf.cols) return;
    let tItems = conf.cols
      .map(function (col) {
        if (col && col.summaryColEnable) {
          let sc = {
            column: col.dataField,
            summaryType: col.summaryType,
            valueFormat: col.summaryDisplayFormat
              ? col.summaryDisplayFormat
              : '#,###,###.##',
            displayFormat: col.summaryDisplayFormat ? '{0}' : '{0}',
          };
          return sc;
        }
        return {} as {
          column: string | undefined;
          summaryType: string | undefined;
          valueFormat: string;
          displayFormat: string;
        };
      })
      .filter((x) => x && x.summaryType);

    let gItems = conf.cols
      .map(function (col) {
        if (col && col.summaryColGroupEnable) {
          var sc = {
            column: col.dataField,
            summaryType: col.summaryType,
            valueFormat: col.summaryDisplayFormat
              ? col.summaryDisplayFormat
              : '#,###,###.##',
            displayFormat: col.summaryDisplayFormat ? '{0}' : '{0}',
            alignByColumn: col.alignByColumn,
          };
          return sc;
        }
        return {} as {
          column: string | undefined;
          summaryType: string | undefined;
          valueFormat: string;
          displayFormat: string;
        };
      })
      .filter((x) => x && x.summaryType);
    this.summaries = tItems;
    this.dataGrid.summary.totalItems = tItems;
    this.dataGrid.summary.groupItems = gItems;
  }

  private async refreshColumnsConf() {
    let conf = this._gridConfiguration;
    let adminAction: any[] = [];
    let userAction: any[] = [];
    // await this.refreshLookupDataSource(conf);

    var l = this._gridConfiguration?.cols?.length;
    if (!this._gridConfiguration?.cols) {
      return;
    }
    this._gridConfiguration.cols.forEach((col) => {
      if (!col.allowExporting) {
        col.allowExporting = false;
      }
    });
    if (this.dataGrid && this._gridConfiguration && l && l > 0) {
      if (this._gridConfiguration.actions) {
        adminAction = this._gridConfiguration.actions.filter(
          (value) => value.onlyAdmin,
        );
        userAction = this._gridConfiguration.actions.filter(
          (value) => !value.onlyAdmin,
        );
        adminAction.map((x) => (x.dataField = x.id));
        userAction.map((x) => (x.dataField = x.id));
      }
      if (
        !this.usersService.getUserData()?.isAdmin &&
        this._gridConfiguration?.cols
      ) {
        this.columns = [...this._gridConfiguration.cols, ...userAction];
      } else if (this._gridConfiguration?.cols) {
        this.columns = [
          ...this._gridConfiguration.cols,
          ...userAction,
          ...adminAction,
        ];
      }
      this.columns.map((x) => {
        if (x.width == 'null' || x.width == '') x.width = null;
        if (x.primaryKey) {
          if (this.dataGrid) {
            if (!Array.isArray(this.dataGrid.keyExpr)) {
              this.dataGrid.keyExpr = [];
            }
            this.dataGrid.keyExpr.push(x.dataField);
          }
        }
        if (!x.dataField && x.__KEY__) {
          // caso action
          x.dataField = x.__KEY__;
          x.caption = '';
        }

        if (x.cellTemplate && !x.customCellTemplate) {
          x.customCellTemplate = JSON.parse(JSON.stringify(x.cellTemplate));
          x.cellTemplate = 'Template';
        } else if (!x.cellTemplate) {
          x.cellTemplate = 'Template';
          if (x.dataType == 'boolean') {
            x.customCellTemplate = 'Bool';
          } else {
            x.customCellTemplate = 'Default';
          }
        }
      });
      this.processStateColumns(this._state);
      document.documentElement.style.setProperty(
        '--grid-header-margin-top',
        this._gridConfiguration.headerFilterEnabled ? '0px' : '0px',
      );
      this.columns.map((x) => {
        x.caption = this.i18nService.translate(x.caption);
        // console.log(this.sizeDetectorService.currentSize);
        if (
          x.hideOnTablets &&
          (this.sizeDetectorService.currentSize.deviceType?.toLowerCase() ==
            'tablet' ||
            this.sizeDetectorService.currentSize.isMobile)
        ) {
          x.visible = false;
        }
      });
      // this.dataGrid.columns = jsonDeepClone(this.columns);
      if (this._state) {
        this.dataGrid.filterValue = this._state.filterValue ?? [];
      }
      this.dataGrid.instance.repaint();
      // console.log(this.gridId + '3');
      let t = setTimeout(() => {
        if (this.dataGrid) {
          this.dataGrid.columns = jsonDeepClone(this.columns);
          // console.log('Colonne', this.dataGrid.columns);
        }
      });
      this._timeouts.push(t);
    }
  }

  private processStateColumns(state: any) {
    if (state && state.columns) {
      state.columns.forEach((stateColumn: any) => {
        var currentCol = this.columns.find(
          (x) => x.dataField == stateColumn.dataField,
        );
        if (currentCol) {
          currentCol.groupIndex = stateColumn.groupIndex;
          currentCol.selectedFilterOperation =
            stateColumn.selectedFilterOperation;
          currentCol.sortOrder = stateColumn.sortOrder;
          currentCol.visible = stateColumn.visible;
          currentCol.visibleIndex = stateColumn.visibleIndex;
          currentCol.sortIndex = stateColumn.sortIndex;
          currentCol.sortOrder = stateColumn.sortOrder;
        }
      });
    }
  }

  private getMenuAndModeId(routeParam: string): string {
    if (!routeParam) return routeParam;
    if (routeParam.indexOf('|') > 0) {
      var splitted = routeParam.split('|', 2);
      if (splitted && splitted.length > 0) {
        return splitted[0];
      }
    }
    return routeParam;
  }

  private getRouteParamsV2(routeParam: string, row: any): SiaSessionParam[] {
    if (!routeParam) return [];
    if (routeParam.indexOf('|') == -1) return [];
    var splitted = routeParam.split('|');
    if (splitted && splitted.length >= 2) {
      var res: SiaSessionParam[] = [];
      for (let index = 1; index <= splitted.length; index++) {
        var params = splitted[index];
        res = res.concat(
          this.pAndPService.resolveParamsPattern(
            params,
            row.data,
            this.pageData.guid ?? '',
          ),
        );
      }
      return res;
    }
    return [];
  }

  private getDateFromElement(element: string): Date {
    var finalDate: Date = new Date();
    var stringDate;
    if (element.startsWith('#') && element.endsWith('#')) {
      var l = (element.length ?? 0 > 2) ? element.length - 2 : 0;
      stringDate = element.substr(1, l).split('/', 3);
      if (stringDate) {
        finalDate = new Date(
          +stringDate[2],
          +stringDate[1] - 1,
          +stringDate[0],
        );
      }
    }
    return finalDate;
  }

  // private checkDate(
  //   fullDate: Date,
  //   stringDate: string,
  //   operator: string
  // ): boolean {
  //   if (!fullDate || !stringDate) return false;
  //   var testDate = this.getDateFromElement(stringDate);
  //   if (!testDate) return false;
  //   var date: Date = new Date(
  //     fullDate.getFullYear(),
  //     fullDate.getMonth(),
  //     fullDate.getDate()
  //   );
  //   switch (operator) {
  //     case '<': {
  //       if (date.getTime() < testDate.getTime()) return true;
  //       break;
  //     }
  //     case '<=': {
  //       if (date.getTime() <= testDate.getTime()) return true;
  //       break;
  //     }
  //     case '>': {
  //       if (date.getTime() > testDate.getTime()) return true;
  //       break;
  //     }
  //     case '>=': {
  //       if (date.getTime() >= testDate.getTime()) return true;
  //       break;
  //     }
  //     case '=': {
  //       if (date.getTime() == testDate.getTime()) return true;
  //       break;
  //     }
  //     case '!=': {
  //       if (date.getTime() != testDate.getTime()) return true;
  //       break;
  //     }
  //     default: {
  //       return false;
  //     }
  //   }
  // }

  private clearActualState() {
    if (!this.sessionService) return;
    if (!this._gridId) return;
    if (!this._deviceType) return;
    var guid = this.pageData.guid;
    if (!guid) return;
    this.clearGridState(this._gridId, this._deviceType, guid);
  }
  //#endregion

  //#region protected methods
  protected manageActionFired(firedAction: SiaActionFired) {
    if (!firedAction || !firedAction.action) {
      return;
    }

    switch (firedAction.action.id) {
      // case 'choice':
      //   this.onChoiceClick();
      //   break;
      case 'save-grid-conf':
        this.onSaveActualConfig();
        break;
      case 'configure':
        this.onConfigClick();
        break;
      case 'expand':
        this._autoExpand = true;
        break;
      case 'collapse':
        this._autoExpand = false;
        break;
      case 'create':
        this.addRow();
        break;
      // case 'refresh':
      //   this.refreshGridInstance();
      //   break;
      case 'column-chooser':
        this.showColumnChooser();
        break;
      case 'export-excel':
        // this.exportExcel();
        break;
      case 'search':
        break;
      case 'enable-filters':
        this._gridConfiguration.filterRowEnabled =
          !this._gridConfiguration.filterRowEnabled;
        this.checkFilterRow();
        break;

      default:
        break;
    }
  }

  private onChoiceClick() {
    var choices = {
      title: this.gridConf.choisesTitle,
      items: this.gridConf.choisesItems,
    };
    // console.log('Choices', choices);
    var dialogRef = this.dialog.open(SiaChoiceDialogComponent, {
      width: '250px',
      data: choices,
    });
    let s0 = dialogRef.afterClosed().subscribe((page: any) => {
      // console.log('Chiuso Dialog !!!', page);
      if (page) {
        if (page) {
          this.navigatePage(page);
        }
      }
    });
    this._subs.push(s0);
  }
  //#endregion

  //#region hooks
  ngAfterViewInit(): void {
    let s1 = this.routerService.routeChanged$.subscribe(() => {
      var pageData: any = null;
      runInInjectionContext(this.injector, () => {
        pageData = retriveCurrentRouteData() ?? {};
      });
      if (!pageData?.guid || pageData?.guid == this.pageData?.guid) {
        return;
      }
      this.pageData = pageData!;
      if (!this.haveInputGridId) {
        this.radarSelection = this.sessionService.getSessionParamValue(
          pageData.key + '-selection',
        );
        this.isRadar = this.sessionService.getSessionParamValue('isRadar');
        this.baseOperations(pageData.key);
      }
    });
    this._subs.push(s1);

    let s4 = this.utilsService.onGridInsertedRowChanged$.subscribe(
      (rowData: any) => {
        if (!this.dataGrid) return;
        if (!rowData) return;
        var key: any = {};
        this._keysIds.forEach((element) => {
          key[element] = rowData[element];
        });
        if (!this.selectedKeys) this.selectedKeys = [{}];
        this.selectedKeys.push(key);
        this.dataGrid.selectedRowKeys = this.selectedKeys ?? [];
      },
    );
    this._subs.push(s4);
  }
  private baseOperations(pageKey: string) {
    this.reloadingConfiguration = true;
    if (!this.usersService.getUserData()?.isAdmin) {
      this.usersService
        .geSiaUserPermissions(pageKey ?? '')
        .then((data: SiaUserPermissions) => {
          this._permissions = data;
        });
    } else {
      this._permissions = {
        canRead: true,
        canCreate: true,
        canUpdate: true,
        canDelete: true,
      };
    }
    this.firstLoad = true;
    this._store = undefined;
    this._gridConfiguration = {};
    this._prefiltersHardSubScription?.unsubscribe();
    this._gridId = pageKey;
    this._gridConfId = this._gridId;
    this.clearDataGridInstance();
    this.updateGridConfig();
    if (this.isRadar && this.dataGrid) {
      this.selectedKeys =
        this.sessionService.getSessionParamValue('selected-ids');
    }
  }

  //#endregion

  getDate() {
    return new Date();
  }

  // getLookupDataSource(tableName: string) {
  //   // let collection = this.kvpService.getKvpTableValues(tableName, false);
  //   // return collection;
  //   return this.widgetDataService.loadFullData(tableName, '', true);
  // }

  onRouteClick(data: any) {
    if (data.column.onClick) return;

    let routeParam = this.getConfParamValue(data);
    // mi aspetto una string di questo tipo
    // maschera|@parametro1=[NomeCampo],@parametro2='COSTANTE'
    var menuAndModeStr = this.getMenuAndModeId(routeParam);
    var menuAndMode = menuAndModeStr?.split('/');
    var menuId = '';
    var mode = 'read';
    if (!menuAndMode || menuAndMode.length == 0) {
      return;
    }
    menuId = menuAndMode[0];
    if (menuAndMode && menuAndMode.length == 2) {
      mode = menuAndMode[1];
    }
    var params = this.getRouteParamsV2(routeParam, data);
    let u = { params: params, menuId: menuId };
    this.routerService.navigateMenuWithParams(u.menuId, u.params, mode);
    // this.routeClick.emit(u);
  }

  onRouteClickJsonConfig(data: any) {
    // configuration-gui/template/[templateid]
    let routeParam = this.getConfParamValue(data);
    let elements: string[] = routeParam.split('/');
    if (!elements || elements.length != 3) {
      notify('Impossibile navigare', 2000, 'error');
      return;
    }
    let params: SiaSessionParam[] = [{ id: 'typeid', value: elements[1] }];
    elements[2] = this.pAndPService.resolvePatternValue(
      elements[2],
      data.data,
      this.pageData.guid ?? '',
    );
    if (elements[0] == 'configuration') {
      this.routerService.navigateToComponentJsonConfig(
        elements[1],
        elements[2],
      );
    } else {
    }
    // this.routeClick.emit(u);
  }
  getPageCount() {
    return this.dataGrid?.instance?.pageCount() ?? 0;
  }
  get gridPageSize() {
    if (!this.dataGrid) return 0;
    return this.dataGrid?.instance?.pageSize();
  }
  set gridPageSize(value: number) {
    this.dataGrid?.instance?.pageSize(value);
  }
  get gridPageIndex() {
    if (!this.dataGrid) return 0;
    return this.dataGrid?.instance?.pageIndex();
  }
  set gridPageIndex(value: number) {
    this.dataGrid?.instance?.pageIndex(value);
  }
  getTotalCount() {
    return this.dataGrid?.instance?.totalCount() ?? 0;
  }

  onRouteClickAction(data: any) {
    let routeParam = data.column.cellTemplateParam;
    // mi aspetto una string di questo tipo
    // maschera|@parametro1=[NomeCampo],@parametro2='COSTANTE'

    var menuAndModeStr = this.getMenuAndModeId(routeParam);
    var menuAndMode = menuAndModeStr?.split('/');
    var menuId = '';
    var mode = 'read';
    if (!menuAndMode || menuAndMode.length == 0) {
      // console.warn(
      //   "non posso applicare la navigazione, Il campo parametro del template è nullo"
      // );
      return;
    }
    menuId = menuAndMode[0];
    if (menuAndMode && menuAndMode.length == 2) {
      mode = menuAndMode[1];
    }
    var params = this.getRouteParamsV2(routeParam, data);

    let u = { params: params, menuId: menuId };
    this.routerService.navigateMenuWithParams(u.menuId, u.params, mode);
    // this.routeClick.emit(u);
  }
  haveExternalSource(data: any) {
    return (
      data.data['externalsourcename'] != null &&
      data.data['externalsourcename'].toLowerCase() == 'creditsafe'
    );
  }
  async onDownloadClick(data: any) {
    var paramValue = this.getConfParamValue(data);
    if (!paramValue) {
      return;
    }

    if (!data.row) {
      // console.warn("data.row nullo");
      return;
    }
    if (!data.row.cells) {
      // console.warn("data.row.cells nullo");
      return;
    }
    let value = data.row.data[paramValue.toLowerCase()];
    if (!value) {
      return;
    }
    try {
      await this.file.downloadFile(
        value,
        value.split('\\').pop() || 'download',
        true,
        false,
      );
    } catch (error) {
      console.error('Errore nel download del file:', error);
      notify('Errore nel download del file.', 2000, 'error');
      return;
    }
  }

  async visibilityCheck(data: any): Promise<boolean> {
    // console.log('verifico condizioni');
    if (!data) {
      data['__actionVisible'] = false;
      return Promise.resolve(false);
    }
    if (!data.row.data) {
      data['__actionVisible'] = false;
      return Promise.resolve(false);
    }
    var conditions = data.column.visibilityConditions;
    var script = data.column.visibilityScript;
    if (!conditions && !script) {
      data['__actionVisible'] = true;
      return Promise.resolve(true);
    }

    let res = false;
    if (conditions) {
      res = this.pAndPService.validateConditionParamPattern(
        conditions,
        data.data,
        this.pageData.guid ?? '',
      );
    } else if (script) {
      // console.log('Eseguo script');
      // console.log(this.user);
      res = await this.execScript(script, data.data);
    }
    // console.log('Risultato  condizioni', res);
    data['__actionVisible'] = res;
    return Promise.resolve(res);
  }

  visibilityReportCheck(data: any) {
    if (!data || !data.row.data) return false;
    var conditions = this.gridConf.reportVisibilityCondition;
    if (!conditions) return true;
    var res = this.pAndPService.validateConditionParamPattern(
      conditions,
      data.data,
      this.pageData.guid ?? '',
    );
    return res;
  }

  onGenericClickAction(data: any) {
    if (!data) return;
    if (!data.row.data) return;

    var siaAction: SiaAction = {
      id: data.column.id,
    };
    var actionfired: SiaActionFired = {
      guid: this.pageData.guid,
      componentId: this.pageData.componentId,
      action: siaAction,
      componentParameters: JSON.stringify(data.row.data),
    };
    this.siaActionsService.fireSiaAction(actionfired);
  }
  checkDownloadVisibility(data: any) {
    let paramValue = data.column.cellTemplateParam;
    if (!paramValue) {
      return false;
    }
    if (!data.row) {
      return;
    }
    if (!data.row.cells) {
      return;
    }
    let value = data.row.data[paramValue.toLowerCase()];
    if (!value) {
      return false;
    }
    return true;
  }
  async onDownloadClickAction(data: any) {
    let paramValue = data.column.cellTemplateParam;
    if (!paramValue) {
      return;
    }

    if (!data.row) {
      // console.warn("data.row nullo");
      return;
    }
    if (!data.row.cells) {
      // console.warn("data.row.cells nullo");
      return;
    }
    let value = data.row.data[paramValue.toLowerCase()];
    if (!value) {
      // console.warn("valore nullo");
      return;
    }
    try {
      await this.file.downloadFile(
        value,
        value.split('\\').pop() || 'download',
        true,
        false,
      );
    } catch (error) {
      console.error('Errore nel download del file:', error);
      notify('Errore nel download del file.', 2000, 'error');
      return;
    }
  }
  refreshValidationRulesConf() {
    let conf = this._gridConfiguration;
    if (!conf) return;
    if (!conf.cols) return;
    conf.cols.forEach((x) => {
      //required
      if (x.required) {
        if (!x.validationRules) {
          x.validationRules = [];
        } else {
          // eventualmente tolgo il required per poterlo reinserire in sicurezza
          x.validationRules = x.validationRules.filter(
            (r) => r.type != 'required',
          );
        }
        x.validationRules.push({ type: 'required' });
      } else {
        if (x.validationRules) {
          x.validationRules = x.validationRules.filter(
            (r) => r.type != 'required',
          );
        }
      }

      //email
      if (x.email) {
        if (!x.validationRules) {
          x.validationRules = [];
        } else {
          // eventualmente tolgo il required per poterlo reinserire in sicurezza
          x.validationRules = x.validationRules.filter(
            (r) => r.type != 'email',
          );
        }
        x.validationRules.push({ type: 'email' });
      } else {
        if (x.validationRules) {
          x.validationRules = x.validationRules.filter(
            (r) => r.type != 'email',
          );
        }
      }

      if (x.patternValue) {
        if (!x.validationRules) {
          x.validationRules = [];
        } else {
          // eventualmente tolgo il required per poterlo reinserire in sicurezza
          x.validationRules = x.validationRules.filter(
            (r) => r.type != 'pattern',
          );
        }
        x.validationRules.push({
          type: 'pattern',
          pattern: x.patternValue,
          message: x.patternMessage,
        });
      }
    });
  }

  getFileIcon(data: any) {
    if (data && data.displayValue) {
      switch (data.displayValue) {
        case 'XLSX':
          return 'fas fa-file-excel fa-2x';
        case 'DOCX':
          return 'fas fa-file-word fa-2x';
        case 'JPG':
          return 'fas fa-file-image fa-2x';
        case 'PNG':
          return 'fas fa-file-image fa-2x';
      }
    }
    return 'fas fa-file fa-2x';
  }
  showSelected() {
    if (!this.dataGrid) {
      return;
    }
    if (!this.selectedRowsVisible) {
      this.dataGrid.dataSource = this.selectedRowsData;
      this.selectedRowsVisible = true;
    } else {
      this.dataGrid.dataSource = this._store;
      this.selectedRowsVisible = false;
    }
  }
  selectionChanged(e: any) {
    // console.log('selectionChanged', this.dataGrid?.selectedRowKeys);
    this.selectedRowsData = e.selectedRowsData;
    this.cdr.detectChanges();
    let keysToRemove: number[] = [];
    if (!this.isRadar) {
      if (
        this.bulkAction &&
        e.selectedRowsData &&
        !this.bulkAction.alwaysPermitSelection &&
        !this.bulkAction?.filterSelectionByCrud
      ) {
        for (let index = 0; index < e.selectedRowsData.length; index++) {
          const data = e.selectedRowsData[index];
          if (
            !this.bulkAction.alwaysPermitSelection &&
            ((this.bulkAction.id == 'delete' &&
              data['__allowdeleteselection'] == false) ||
              (this.bulkAction.id == 'merge' &&
                data['__allowmergeselection'] == false))
          ) {
            keysToRemove.push(index);
          }
        }
      }
      if (this.bulkAction?.filterSelectionByCrud) {
        if (!e.selectedRowsData || e.selectedRowsData.length == 0) {
          this._selectionCrud = null;
          this.dataGrid?.instance.repaint();
          // console.log(this.gridId + '4');
        }
        if (
          e.selectedRowsData &&
          e.selectedRowsData.length > 0 &&
          !this._selectionCrud
        ) {
          this._selectionCrud = e.selectedRowsData[0]['__massiveoperationcrud'];
          // this._comparisonPage = e.selectedRowsData[0]["__comparisoncrud"];
          this.dataGrid?.instance.repaint();
          // console.log(this._selectionCrud);
        }
        for (let index = 0; index < e.selectedRowsData.length; index++) {
          const data = e.selectedRowsData[index];
          if (
            (!this.bulkAction.alwaysPermitSelection &&
              ((this.bulkAction.id == 'delete' &&
                data['__allowdeleteselection'] == false) ||
                (this.bulkAction.id == 'merge' &&
                  data['__allowmergeselection'] == false))) ||
            data['__massiveoperationcrud'] != this._selectionCrud
          ) {
            keysToRemove.push(index);
          }
        }
      }
      if (this.bulkAction.id == 'merge' && e.selectedRowsData.length > 2) {
        keysToRemove.push(0);
      }
      this.selectedRowsData = jsonDeepClone(e.selectedRowsData);
      this.selectedKeys = jsonDeepClone(e.selectedRowKeys);
      keysToRemove = keysToRemove.reverse();
      keysToRemove.forEach((index) => {
        // console.log('Rimuovo', index);
        this.selectedRowsData.splice(index, 1);
        this.selectedKeys.splice(index, 1);
      });
      this.selectedRowsData = jsonDeepClone(this.selectedRowsData);
      this.selectedKeys = jsonDeepClone(this.selectedKeys);
      // console.log('setto selectedKeys', jsonDeepClone(this.selectedKeys));
      this.selectedRowsDataChange.emit(this.selectedRowsData);
      this.selectedKeysChange.emit(this.selectedKeys);
      if (this.dataGrid) {
        this.dataGrid.selectedRowKeys = this.selectedKeys;
      }
    } else {
      this.selectedKeys = jsonDeepClone(e.selectedRowKeys);
      this.siaWidgetDataService.selectionChanged({
        gridId: this.gridId ?? '',
        data: e.selectedRowsData,
        keys: e.selectedRowKeys,
      });
      if (this.radarSelection == 'single') {
        this.routerService.closeOutlet('popup');
      }
    }
  }
  applySelection() {
    let t = setTimeout(() => {
      this.dataGrid?.instance.selectRows(
        jsonDeepClone(this.selectedKeys),
        true,
      );
    });
    this._timeouts.push(t);
  }
  // Azione save della grid
  saved(e: any) {
    this.gridSaved.emit(this._gridId);
  }

  cellPrepared(e: any) {
    if (
      this.bulkAction &&
      e &&
      e.cellElement &&
      e.cellElement.cellIndex == 0 &&
      e.cellElement.children &&
      e.cellElement.children.length == 1 &&
      e['data'] &&
      ((!this.bulkAction.alwaysPermitSelection &&
        ((this.bulkAction.id == 'delete' &&
          e['data']['__allowdeleteselection'] == false) ||
          (this.bulkAction.id == 'merge' &&
            e['data']['__allowmergeselection'] == false))) ||
        (this.bulkAction?.filterSelectionByCrud &&
          this._selectionCrud &&
          e['data']['__massiveoperationcrud'] != this._selectionCrud))
    ) {
      let children: HTMLElement = e.cellElement.children[0];
      if (
        children.className ==
          'dx-widget dx-checkbox dx-select-checkbox dx-datagrid-checkbox-size' ||
        children.className ==
          'dx-widget dx-checkbox dx-checkbox-checked dx-select-checkbox dx-datagrid-checkbox-size'
      ) {
        children.setAttribute('style', 'display: none;');
        e.cellElement.setAttribute('style', 'pointer-events: none;');
        e['data']['__disableSelection'] = true;
      }
    }
    let conf = this._gridConfiguration;
    if (!conf) return;
    this.manageColumnStyle(conf, e);
    this.manageCellStyle(conf, e);
  }

  rowPrepared(e: any) {
    let conf = this._gridConfiguration;
    if (!conf) return;
    if (e.rowType == 'header') return;
    if (e.rowType == 'filter') return;
    this.manageRowHeight(conf, e);
    this.manageRowStyle(conf, e);
    // console.log(e);
    // console.log(e.key, this.clickedKey);
    if (this.clickedKey) {
      if (
        e.rowType == 'data' &&
        JSON.stringify(e.loadIndex) == JSON.stringify(this.focusedRowIndex)
      ) {
        if (JSON.stringify(e.key) == JSON.stringify(this.clickedKey)) {
          var element: HTMLElement = e.rowElement;
          var className = element.className + ' sia-grid-row--selected';

          if (element) element.className = className;
        }
        // console.log('LO SETTO COME SELEZIONATO');
        if (!this.scrolledIntoView) {
          this.scrolledIntoView = true;
          let t = setTimeout(() => {
            e.rowElement.scrollIntoView();
          }, 0);
          this._timeouts.push(t);
        }
      } else if (
        e.rowType == 'data' &&
        JSON.stringify(e.loadIndex) != JSON.stringify(this.focusedRowIndex) &&
        !this.scrolledIntoView &&
        this.settedPageIndex
      ) {
        this.scrollDown();
      }
    }
  }
  scrollDown() {
    clearTimeout(this.scrollTimeout);
    this.scrollTimeout = setTimeout(() => {
      if (!this.scrolledIntoView) {
        let top = this.dataGrid?.instance.getScrollable().scrollTop();
        this.dataGrid?.instance
          .getScrollable()
          .scrollTo(
            (top ?? 0) + this.dataGrid?.instance.getScrollable().clientHeight(),
          );
      }
    }, 200);
  }
  private manageColumnStyle(conf: GridConfig, e: any) {
    var area = 'column';
    this.applyStyleToCell(conf, e, area);
  }

  private manageCellStyle(conf: GridConfig, e: any) {
    var area = 'cell';
    this.applyStyleToCell(conf, e, area);
  }

  private applyStyleToCell(conf: GridConfig, e: any, area: string) {
    if (!conf || !conf.styleConditions) return;
    if (!e || !e.column) return;
    if (e.rowType != 'data') return;

    var df = e.column.dataField;
    if (!df) return;

    var areas: string[] = [];
    if (area) areas.push(area);
    else {
      areas.push('cell');
      areas.push('column');
    }
    areas.forEach((aa) => {
      var areaConditions = (conf.styleConditions ?? []).filter(
        (x) => x.area == aa,
      );

      if (!areaConditions) return;
      var toApply = areaConditions.filter((x) => {
        return x.column === df || !x.column;
      });

      toApply.forEach((c) => {
        var res = false;

        if (c && c.value1 && c.operator) {
          var pattern = c.value1 + c.operator + c.value2;
          res = this.pAndPService.validateConditionParamPattern(
            pattern,
            e.data,
            this.pageData.guid ?? '',
          );
        }

        if (res) {
          var element: HTMLElement = e.cellElement;
          var st = element.getAttribute('style') ?? '';
          let style = this.processStyle(c.cssStyle, e.data);
          if (st) st = st + ';' + style;
          if (element) element.setAttribute('style', st);
        }
      });
    });
  }

  processStyle(styleCss: string | undefined, item: any) {
    var resolvedStyle: string = '';
    if (styleCss) {
      resolvedStyle = this.pAndPService.resolveSquaresInString(styleCss, item);
    }
    return resolvedStyle;
  }

  private manageRowStyle(conf: GridConfig, e: any) {
    if (!conf.styleConditions) return;
    var rConditions = conf.styleConditions.filter((x) => x.area == 'row');
    if (!rConditions || rConditions.length == 0) {
      return;
    }
    this.gridConf.rowAlternationEnabled = false;
    rConditions.forEach((c) => {
      var res = false;
      if (c && c.value1 && c.operator) {
        var pattern = c.value1 + c.operator + c.value2;
        res = this.pAndPService.validateConditionParamPattern(
          pattern,
          e.data,
          this.pageData.guid ?? '',
        );
      }
      if (res && c.cssStyle) {
        var element: HTMLElement = e.rowElement;
        if (element) element.setAttribute('style', c.cssStyle);
      }
    });
  }

  private manageRowHeight(conf: GridConfig, e: any) {
    if (!conf.rowHeight) return;
    if (conf.rowHeight > 0) {
      e.rowElement.style.height = conf.rowHeight + 'px';
    }
  }
  hideButtons(actions: any) {
    // actions.toolbarOptions.visible = false;
    actions.toolbarOptions.items.forEach((action: any) => {
      if (action.name != 'searchPanel' && action.name != 'groupPanel') {
        action.visible = false;
      } else {
        action.location = 'before';
      }
    });
  }
  addRow() {
    const msg = 'Aggiunta di un record non permessa';
    if (!this._gridConfiguration) {
      notify(msg, 1000, 'error');
      return;
    }
    if (this._gridConfiguration.editType === 'navigazione') {
      // console.log('navigazione');
      this.onChoiceClick();
      return;
    }
    if (
      this._gridConfiguration.editType === 'external page' &&
      this._gridConfiguration.externalPage
    ) {
      // console.log('Uso ExternalPage');
      let page = this._gridConfiguration.externalPage;
      this.navigatePage(page);
    }

    if (
      this._gridConfiguration &&
      (this._gridConfiguration.allowAdding ||
        this._gridConfiguration.editType != 'external page')
    ) {
      if (!this.dataGrid) return;
      let t = setTimeout(this.dataGrid?.instance.addRow, 0);
      this._timeouts.push(t);
      return;
    }
  }

  private navigatePage(page: string) {
    // console.log('navigatePage');

    let mode = 'create';
    if (page.indexOf('/') != -1) {
      let pageAndMode = page.split('/');
      if (pageAndMode && pageAndMode.length == 2) {
        page = pageAndMode[0];
        mode = pageAndMode[1];
      }
    }
    if (this._gridConfiguration.editType == 'navigazione') {
      var params = this.getRouteParamsV2(page, {});

      page = page.split('|')[0];
      // console.log('Navigo ', params);
      this.routerService.navigateMenuWithParams(page, params, mode);
      return;
    } else {
      this.routerService.navigateMenuWithParams(page, this._editParams, mode);
    }
  }

  onRouteCrud(event: any) {
    if (event && event.routeValue) {
      this.routerService.navigateMenuWithParams(event.routeValue, []);
    }
  }

  processGridFilters() {
    //     // if (!this.dataGrid) return;
    // for (
    //   let indexGrid = 0;
    //   indexGrid < this.dataGrid?.filterValue?.length;
    //   indexGrid++
    // ) {
    //   const gridFilter = this.dataGrid.filterValue[indexGrid];
    //   if (!gridFilter || typeof gridFilter == 'string') {
    //     continue;
    //   }
    //   var dataField = gridFilter[0];
    //   var value = gridFilter[2];
    //   var col: any = this.columns.find((x: any) => x['dataField'] == dataField);
    //   if (col) {
    //     var dt = col['dataType'];
    //     gridFilter[2] = this.preFilterService.processValue(value, dt);
    //   }
    // }
  }

  addFilter(filters: any[]) {
    let oldFilters = JSON.parse(JSON.stringify(this.dataGrid?.filterValue));

    if (!this.dataGrid || !filters || filters.length == 0) {
      if (this.dataGrid) {
        this.dataGrid.filterValue = [];
      }
      return;
    }
    if (!oldFilters || oldFilters.length == 0) {
      filters = this.clearFilters(filters);
      this.dataGrid.filterValue = filters;
      return;
    }
    if (
      !oldFilters ||
      (oldFilters.length == 1 && typeof oldFilters[0] == 'string')
    ) {
      filters = this.clearFilters(filters);
      this.dataGrid.filterValue = filters;
      return;
    }

    var indexesToRemove: number[] = [];
    for (let index = 0; index < filters.length; index++) {
      const element = filters[index];
      if (!element || typeof element == 'string') {
        continue;
      }
      var key = element[0];
      var symbol = element[1];
      for (let indexGrid = 0; indexGrid < oldFilters.length; indexGrid++) {
        let gridFilter = oldFilters[indexGrid];
        if (!gridFilter || typeof gridFilter == 'string') {
          continue;
        }
        if (gridFilter && key == gridFilter[0] && symbol == gridFilter[1]) {
          if (indexGrid != oldFilters.length - 1) {
            indexesToRemove.push(indexGrid + 1);
          } else {
            indexesToRemove.push(indexGrid - 1);
          }
          indexesToRemove.push(indexGrid);
        }
      }
    }
    indexesToRemove = indexesToRemove.filter(function (elem, index, self) {
      return index === self.indexOf(elem);
    });
    indexesToRemove.sort((a, z) => z - a);
    indexesToRemove.forEach((element) => {
      if (element < oldFilters.length) {
        oldFilters.splice(element, 1);
      }
    });
    if (oldFilters && oldFilters.length == 2) {
      oldFilters.splice(1, 1);
    }
    if (
      oldFilters &&
      oldFilters.length > 0 &&
      typeof oldFilters[oldFilters.length - 1] == 'string'
    ) {
      oldFilters.splice(oldFilters.length - 1, 1);
    }

    oldFilters = this.clearFilters(oldFilters);
    filters = this.clearFilters(filters);
    let t = setTimeout(() => {
      if (this.dataGrid) {
        if (oldFilters.length == 0) {
          this.dataGrid.filterValue = filters;
        } else if (filters.length > 0) {
          this.dataGrid.filterValue = [...oldFilters, ...['and'], ...filters];
        }
      }
    }, 0);
    this._timeouts.push(t);
  }

  private clearFilters(filters: any[]) {
    let indexesToRemove = [];
    for (let indexGrid = 0; indexGrid < filters.length; indexGrid++) {
      let filter = filters[indexGrid];
      if (typeof filter == 'string') {
        continue;
      }
      let filterValue: any = filter[2];
      if (
        (!filterValue && typeof filterValue != 'boolean') ||
        (Array.isArray(filterValue) &&
          filterValue.every((element) => element === null))
      ) {
        if (indexGrid != filters.length - 1) {
          indexesToRemove.push(indexGrid + 1);
        } else {
          indexesToRemove.push(indexGrid - 1);
        }
        indexesToRemove.push(indexGrid);
      }
    }
    indexesToRemove = indexesToRemove.filter(function (elem, index, self) {
      return index === self.indexOf(elem);
    });
    indexesToRemove.sort((a, z) => z - a);
    indexesToRemove.forEach((element) => {
      if (element < filters.length) {
        filters.splice(element, 1);
      }
    });

    if (filters && filters.length == 2) {
      filters.splice(1, 1);
    }
    if (
      filters &&
      filters.length > 0 &&
      typeof filters[filters.length - 1] == 'string'
    ) {
      filters.splice(filters.length - 1, 1);
    }
    return filters;
  }

  getRouterValue(data: any) {
    if (!data || !data.value) {
      if (
        data.column &&
        data.column.dataType &&
        data.column.dataType == 'number'
      )
        return 0;
      return 'link';
    }
    return data.value;
  }

  loadState = () => {
    if (!this._gridId) {
      return null;
    }
    this._state = this.dataService.getGridState(this.getGridStateSessionKey());

    if (!this._state) {
      return;
    }
    if (this.selectedKeys) {
    } else {
      if (this._state && this._state.selectedRowKeys)
        this._state.selectedRowKeys = []; // SE VUOI TOGLIERE IL SALVATAGGIO DEI SELEZIONATI
    }

    if (
      this._state.filterValue &&
      Array.isArray(this._state.filterValue) &&
      this._state.filterValue.length > 0 &&
      !Array.isArray(this._state.filterValue[0])
    ) {
      this._state.filterValue = [this._state.filterValue];
    } else {
    }
    if (!this.dataGrid || !this._state?.filterValue) {
      return;
    }
    this._state.filterValue.forEach((filterEl: any) => {
      if (Array.isArray(filterEl)) {
        var col = this._state.columns.find(
          (x: any) => x.dataField == filterEl[0],
        );
        if (col?.dataType == 'date') {
          filterEl[2] = new Date(filterEl[2]);
        }
      }
    });
    this.columns.map((x) => {
      x.caption = this.i18nService.translate(x.caption);
    });
    this.dataGrid.instance.repaint();
    // console.log(this.gridId + '6');
    this.reloadPageIndex = this._state.reloadPageIndex;
    this.statePageIndex = this._state.gridPageIndex;
    this.clickedKey = this._state.clickedKey;
    this.focusedRowIndex = this._state.focusedRowIndex;
    this.dataGrid?.instance.selectRows(this.selectedKeys, false);
    this.cdr.detectChanges();
    this.pageSize = this._state.pageSize;
    // console.log('recuperoStato', this._state);
    return this._state;
  };

  saveState = (state: any) => {
    if (this.reloadingConfiguration) {
      return;
    }
    this.processStateColumns(state);
    if (this.dataGrid?.columns) {
      this.dataGrid.columns = this.columns;
    }
    if (!state) return;
    if (!this.sessionService) return;
    if (!this._gridId) return;
    if (!this._deviceType) return;
    if (!this.pageData.guid) return;
    state.reloadPageIndex = this._reloadPageIndex;
    state.gridPageIndex = this.dataGrid?.instance.pageIndex() ?? 0;
    state.clickedKey = this.clickedKey;
    state.focusedRowIndex = this.focusedRowIndex;
    // console.log('SALVO STATO', state);
    this.latestSavedState = state;
    this.dataService.saveGridState(this.getGridStateSessionKey(), state);
  };
  char2BoolChange(data: any) {
    if (data.value) {
      if (data.value == 'S') {
        data.setValue('N');
      } else {
        data.setValue('S');
      }
    }
  }

  valueChange(e: any, data: any) {
    data.setValue(e.value);
  }

  destroyDxComponent(dxComponent: any, clientId: string) {
    if (dxComponent && dxComponent.instance) {
      dxComponent.instance.dispose();
      dxComponent = null;
      var doc = document.getElementById(clientId);
      if (doc) doc.remove();
    }
  }

  manageCellClick(data: any) {
    this.clickedKey = data.key;
    this.focusedRowIndex = data.row?.loadIndex;
    this.saveState(this.latestSavedState);
    if (!data.column.onClick || data.column.onClick == '') return;

    var conditions = data.column.clickEnableCondition;
    if (conditions) {
      var res = this.pAndPService.validateConditionParamPattern(
        conditions,
        data.data,
        this.pageData.guid ?? '',
      );
      if (!res) return;
    }

    this.componentService.processAction(data.column.onClick, data.data);
  }
  onReportLinkClickAction(data: any) {
    let keysId: string[] = [];
    let params: SiaSessionParam[] = [];

    this._gridConfiguration?.cols?.forEach((col) => {
      if (col.primaryKey) {
        if (col.dataField) keysId.push(col.dataField);
      }
    });
    if (keysId.length >= 1) {
      let keys: any[] = [];
      keysId.forEach((keyId) => {
        let keyValue = data.row.data[keyId];
        let key = keyId.concat('=', keyValue);
        keys.push(key);
        params.push({ id: keyId, value: keyValue });
      });
    }
    if (this._gridConfiguration.reportParams) {
      let reportParams = this.pAndPService.resolveParamsPattern(
        this._gridConfiguration.reportParams,
        data.row.data,
        this.pageData.guid ?? '',
      );
      if (reportParams) {
        params = [...params, ...reportParams];
      }
    }
    var r = {
      reportName: this._gridConfiguration.reportName ?? '',
      reportParams: params,
      saveFile: true,
    };
    return this.siaReportPrintService.downloadReport(r);
  }

  getPosNegClass(n: any) {
    if (n == 0) {
      return 'zero';
    }
    if (n > 0) {
      return 'inc';
    } else {
      return 'dec';
    }
  }

  number2date(date: number) {
    return this.dateService.number2date(date);
  }

  date2Number(e: any, data: any) {
    let newDateInt = this.dateService.date2number(e.value);
    if (newDateInt) data.setValue(newDateInt.date);
  }

  emitGridKey(data: any, actionId: string) {
    if (data) {
      let keysId: string[] = [];
      this._gridConfiguration?.cols?.forEach((col) => {
        if (col.primaryKey) {
          if (col.dataField) keysId.push(col.dataField);
        }
      });
      if (keysId.length >= 1) {
        let keys: any[] = [];
        keysId.forEach((keyId) => {
          let keyValue = data.row.data[keyId];
          let key = keyId.concat('=', keyValue);
          keys.push(key);
        });
        let rowKeysData = {
          menuId: this._gridId,
          actionId: actionId,
          params: keys,
        };
        this.gridAction.emit(rowKeysData);
      }
    }
  }

  getText(data: any) {
    if (!this._isMobile) {
      if (data.column.buttonText) {
        return this.i18nService.translate(data.column.buttonText);
      }
      return '';
    }
    return '';
  }

  getIcon(data: any) {
    // console.log(data);
    if (data.column.icon) {
      if (data.column.icon.indexOf('[') == -1) {
        return data.column.icon;
      } else {
        return this.pAndPService.resolvePatternValue(
          data.column.icon,
          data.row.data,
          '',
        );
      }
    }
    return '';
  }

  rowInserted(event: any) {
    this.invalidateCache();
  }

  rowUpdated(event: any) {
    this.invalidateCache();
  }
  rowDeleted(event: any) {
    this.invalidateCache();
  }
  //invalida la cache se i dati nella grid vengono aggiunti modificati o eliminati.
  //se non è presente cache non fa nulla
  private invalidateCache() {
    if (!this.gridConf.useCache) return;
    var k = this._gridId;
    if (this.gridConf.cacheKey) k = this.gridConf.cacheKey;
    // this.cacheService.clearComponentCaDcheData(this._gridId, k);
  }

  test(e: any) {}
  //#endregion
}
